export default "__VITE_ASSET__BrkKOVSs__"